"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _BackButton = _interopRequireDefault(require("./BackButton.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BackButton = _ref => {
  let {
    lang
  } = _ref;
  const systemLink = (0, _useSystemLinks.default)();
  const css = (0, _BackButton.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const shopUrl = systemLink("shop");
  const handleClick = event => {
    if ("referrer" in document) {
      const hostname = window.location.hostname;
      if (document.referrer.indexOf(hostname) > 0) {
        event.preventDefault();
        window.history.back();
        return;
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
    className: (0, _clsx.default)(css.backButton, "mco-shop-product-detail-back-button"),
    to: shopUrl,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    className: css.icon,
    src: "/img/icons/chevron-left.svg",
    size: 20
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.title
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.labels.backToOverview",
    l: l
  })));
};
BackButton.propTypes = {
  lang: _propTypes.default.string
};
var _default = exports.default = BackButton;